import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {

} from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain, Page, VersionManagement,
} from '../../components';
import config from '../../config';
import './versionmanagement.global.scss';

interface Props {
  scrollingDisabled: boolean,
  intl: any,
}

const VersionManagementComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'VersionManagement.Page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <VersionManagement />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const VersionManagementComponentComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(VersionManagementComponent);

export default VersionManagementComponentComponentPage;
